<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('my_student_clubs')"
                        :isFilter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('my_student_clubs')"
                              :isFilter="false" />
            </template>
            <b-row>
                <b-col cols="12">
                    <b-row>
                        <b-col cols="12" md="3" lg="3" v-for="club in clubs" :key="club.id">
                            <b-card class="mb-2" :title="club.student_club.name" align="center">
                                <b-card-text class="text-primary" style="font-size: 68px">
                                    <i class="ri-team-fill"></i>
                                </b-card-text>
                                <b-card-text>
                                    {{$t('member_at')}}: {{club.membership_date}}
                                </b-card-text>
                                <b-row>
                                    <b-col cols="12" class="d-flex justify-content-center">
                                        <b-dropdown :disabled="club.status == 'waiting_payment'" variant="primary" class="mx-1" :text="$t('manage')">
                                            <b-dropdown-item v-if="['president','vice_president'].includes(club.role)" @click="openManageModal('club-management','xxl', club)"><i class="ri-arrow-right-s-fill"></i> {{$t('manage_the_club')}}</b-dropdown-item>
                                            <b-dropdown-item @click="openManageModal('club-votes','xxl', club)"><i class="ri-arrow-right-s-fill"></i> {{$t('club_votes')}}</b-dropdown-item>
                                            <b-dropdown-item v-if="club.role != 'member'" @click="openManageModal('club-president-request','lg', club)"><i class="ri-arrow-right-s-fill"></i> {{$t('club_manager_candidacy')}}</b-dropdown-item>
                                            <b-dropdown-item v-if="checkPermission('studentclubstudent_leaveclub') && club.role != 'member'" @click="leaveTheClub(club)"><i class="ri-arrow-right-s-fill"></i> {{$t('club_leaving')}}</b-dropdown-item>
                                        </b-dropdown>
                                        <b-button variant="warning" v-if="club.status == 'waiting_payment'" @click="openManageModal('do-payment','lg', club, true)">{{ $t('make_payment') }}</b-button>
                                    </b-col>
                                </b-row>

                            </b-card>
                        </b-col>
                        <b-col cols="12" md="3" lg="3">
                            <b-card class="mb-2" :title="$t('new').toUpper()" align="center">
                                <b-card-text class="text-success" style="font-size: 68px">
                                    <i class="ri-team-fill"></i>
                                </b-card-text>
                                <b-card-text>
                                    {{$t('club_serch')}}
                                </b-card-text>
                                <b-row>
                                    <b-col cols="12" class="d-flex justify-content-center">
                                        <b-button variant="success" @click="joinClubs('club-search','xxl', {student_club: {name: $t('club_serch')}})">{{$t('join')}}</b-button>
                                    </b-col>
                                </b-row>

                            </b-card>
                        </b-col>


                    </b-row>
                </b-col>
            </b-row>
            <CommonModal ref="manageModal" :size="modalSize" :onHideOnlyX="true" @bHideModalHeaderClose="setClosed">
                <template v-slot:CommonModalTitle>
                    {{ modalTitle }}
                </template>
                <template v-slot:CommonModalContent>
                    <component v-if="modalComponent" :is="modalComponent" :clubData="modalData" @onUpdated="closeManageModal" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import CommonModal from '@/components/elements/CommonModal'

    //Page
    import ClubVotes from "@/modules/studentClubs/pages/student/ClubVotes"
    import ClubPresidentRequest from "@/modules/studentClubs/pages/student/ClubPresidentRequest"
    import ClubSearch from "@/modules/studentClubs/pages/student/ClubSearch"
    import DoPayment from "@/modules/studentClubs/pages/student/DoPayment"
    import ClubManagement from "@/modules/studentClubs/pages/student/ClubManagement"

    //Service
    import StudentClubService from '@/services/StudentClubService';
    import qs from "qs";
    import ConstantService from "@/services/ConstantService";

    //Other


    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            CommonModal,
            ClubVotes,
            ClubPresidentRequest,
            ClubSearch,
            DoPayment,
            ClubManagement

        },

        metaInfo() {
            return {
                title: this.$t('my_student_clubs')
            }
        },

        data() {
            return {
                clubs: [],
                modalTitle: null,
                modalComponent: null,
                modalSize: null,
                modalData: null,
                refreshMode: false
            }
        },

        methods: {
            getClubs() {
                StudentClubService.getMyClubs().then(response => {
                    this.clubs = response.data.data
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            openManageModal(component, size, data, refresh = false) {
                this.modalSize = size
                this.modalData = data
                this.modalComponent = component
                this.modalTitle = data.student_club.name
                this.$refs.manageModal.$refs.commonModal.show()
                if (refresh) {
                    this.refreshMode = true
                }
            },

            setClosed() {
                this.modalComponent = null
                if (this.refreshMode) {
                    this.getClubs()
                    this.refreshMode = false
                }
            },

            closeManageModal() {
                this.$refs.manageModal.$refs.commonModal.hide()
                this.getClubs()
            },

            leaveTheClub(club){
                this.$swal.fire({
                        text: this.$t('club_leaving_info',{club_name: club.student_club.name}),
                        showCancelButton: true,
                        confirmButtonText: this.$t('yes'),
                        cancelButtonText: this.$t('no'),
                        icon: 'question'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            StudentClubService.leaveTheClub(club.student_club_id).then(response => {
                                this.$toast.success(this.$t('api.'+response.data.message))
                                this.getClubs()
                            }).catch(e => {
                                this.showErrors(e, null)
                            })
                        }
                    })
            },

            joinClubs(component, size, data, refresh){
                StudentClubService.joinClubDateControl().then(response => {
                    let result = response.data.data
                    if (result) {
                        this.openManageModal(component, size, data, refresh)
                    } else {
                        const config = {
                            params: {
                                key: 'student_club_students.join_club_date_control_message'
                            },
                            paramsSerializer: (params) => qs.stringify(params, { encode: false })
                        };
                        ConstantService.getValue(config).then(response => {
                            this.$swal.fire({
                                icon: 'warning',
                                title: this.$t('warning'),
                                text: response.data.data,
                                showCancelButton: false,
                                confirmButtonText: this.$t('ok')
                            })
                        }).catch(e => {
                            this.showErrors(e, null)
                        });
                    }
                }).catch(e => {
                    this.showErrors(e, null)
                })
            }
        },

        created() {
            this.getClubs()
        }
    }
</script>
